import { DefaultTheme, ThemeProvider as RNThemeProvider } from '@react-navigation/native'
import type { ReactNode } from 'react'

type ThemeProviderProps = {
  children: ReactNode
  colors?: Partial<typeof DefaultTheme.colors>
}

export const ThemeProvider = ({ children, colors }: ThemeProviderProps): ReactNode => (
  <RNThemeProvider value={{ ...DefaultTheme, colors: { ...DefaultTheme.colors, ...colors }, dark: false }}>
    {children}
  </RNThemeProvider>
)
